<template>
  <HeadlessTransitionRoot
    :show="isOpen"
    as="template"
  >
    <HeadlessDialog
      as="div"
      class="relative z-[100]"
      @close="store.close"
    >
      <HeadlessTransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-black bg-opacity-25">
          <MouseFollower :hide-when-over-el="dialogPanelEl" />
        </div>
      </HeadlessTransitionChild>

      <div class="fixed bottom-0 left-0 top-0 w-screen overflow-y-auto">
        <div class="flex min-h-full items-center justify-center p-4 text-center">
          <HeadlessTransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <HeadlessDialogPanel class="w-full max-w-2xl rounded-2xl shadow-xl transition-all">
              <div
                ref="dialogPanelEl"
                class="document w-full rounded-2xl bg-whitegray p-8 text-left text-lg whitespace-pre-line"
              >
                  <h3 class="text-2xl font-medium mb-2" v-if="title.length > 0"> {{ title }} </h3>

                {{ message }}
              </div>
            </HeadlessDialogPanel>
          </HeadlessTransitionChild>
        </div>
      </div>
    </HeadlessDialog>
  </HeadlessTransitionRoot>
</template>

<script setup lang="ts">

import { storeToRefs } from 'pinia'
import { useAlertDialogStore } from '~/store/alertDialog'

const store = useAlertDialogStore()
const { isOpen, message, title } = storeToRefs(store)


const dialogPanelEl = ref()
</script>
